import React, { useState, useMemo, useRef, useEffect } from 'react';
import {EuiFlexGroup, EuiBasicTable, EuiHealth,  EuiFlexItem, EuiFormRow, EuiLoadingSpinner, EuiText, EuiButtonIcon, CENTER_ALIGNMENT, SortDirection} from '@elastic/eui';
import moment from 'moment';

import './styles.css';
import { SelectorPeriodosContainer as SelectorPeriodos} from '../../../../components/Selectores/Periodos/container';
import { SelectorTiposContenidoContainer as SelectorTiposContenido } from '../../../../components/Selectores/TiposContenidoAñoPeriodo/container';
import { SelectorEjercicioContainer as SelectorEjercicio} from '../../../../components/Selectores/Ejercicio/container';
import { formatDateTime } from  '../../../../../../shared/utils/fecha';

import { Action } from '../../../../components/Menus/interface';
import { Menu } from '../../../../components/Menus';
import { DetalleContent } from '../Components/detalleContent';
import { TablaLogImportaciones } from '../Components/tablaLog';


interface dataRequest {año:number, periodo:number, IdTipo: string}

interface Props {
  onFilter(data: dataRequest): void;
  onDetalleFilter(data: any): void;
  data: any;
  dataDetalle: any;
  isLoading: boolean;
}

export const LogImportacionesScreen = (props: Props) => {

  let { onFilter, onDetalleFilter, data, dataDetalle, isLoading } = props;
  const ref:any = useRef();
  
  const _año = parseInt(moment().format('M')) === 1 ? parseInt(moment().format('Y'))-1 : parseInt(moment().format('Y'));

  const [año, setAño] = useState<number>(_año);
  const [periodo, setPeriodo] = useState<any>(undefined);
  const [tipocontenido, setTipoContenido] = useState<any>(undefined);

  const onChangePeriodo = (value:any) => {
    setPeriodo(value)
  }

  const onTipoContenidoChange = (value: any) => {
    setTipoContenido(value);
  }

  const getRequesData = () => {
    const reqdata : dataRequest = {
      año : año, periodo: periodo, IdTipo: tipocontenido
    }
    return (
      reqdata
    )
  }

  const onFiltrar = () =>{
    onFilter(getRequesData());
  }  

  const Actions: Action[] = useMemo(()=>[
    {handle:onFiltrar,text:"Filtrar",size:"s", isDisabled: isLoading}
  ],[onFiltrar, data])

  return (
    <>
      <EuiFlexGroup style={{height:'100%'}} className={"collapsePanel"}>
        <EuiFlexItem>
            <EuiFormRow>
              <SelectorEjercicio value={año} onChange={(e:any) => setAño(e)} permitirNuevo={true} />
            </EuiFormRow>
            <EuiFormRow>
              <SelectorPeriodos fullWidth valueOfSelected={periodo} onChange={(value: any) => onChangePeriodo(value)} año={año} />
            </EuiFormRow>
            <EuiFormRow>
              <SelectorTiposContenido valueOfSelected={tipocontenido} onChange={onTipoContenidoChange} año={año} periodo={periodo} />
            </EuiFormRow>
        </EuiFlexItem>
        <EuiFlexItem style={{height: "100%",padding: "0.2rem", overflow:"hidden", marginBottom:'5px'}}>
          <EuiFlexGroup alignItems='baseline'>
            <EuiFlexItem>
            <EuiFlexGroup alignItems='center' >
              <EuiFlexItem grow={false}>
              </EuiFlexItem>
              <EuiFlexItem grow={false}>
              </EuiFlexItem>
              <EuiFlexItem>
                <Menu actions={Actions}/>
              </EuiFlexItem>
            </EuiFlexGroup>
          </EuiFlexItem>
          </EuiFlexGroup>
          <EuiFlexGroup style={{height:'95%', flexDirection:'column'}}>
              <EuiFlexItem grow={false} style={{marginBottom:'0', alignItems: 'center', overflowX:'auto', overflowY:'auto'}}>
                {isLoading && <EuiLoadingSpinner size="xl" />}
                {!isLoading && data.length > 0 && 
                <TablaLogImportaciones data={data} onDetalleFilter={onDetalleFilter}/>
                }
              </EuiFlexItem>
            </EuiFlexGroup>
          </EuiFlexItem>
          </EuiFlexGroup>
    </>
  );
};

export default LogImportacionesScreen;
